import React from "react";

interface ButtoProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  content?: string;
  variant?:
    | "outline"
    | "solid"
    | "cancel"
    | "outlinePurple"
    | "outlineRed"
    | "solidPurple"
    | "cancelPurple";
  iconUrl?: string;
}

import styles from "./styles.module.scss";

export function Button({
  content,
  variant = "solid",
  iconUrl,
  ...rest
}: ButtoProps) {
  return (
    <button className={`${styles.button} ${styles[variant]}`} {...rest}>
      {iconUrl && <img src={iconUrl} />}
      {content}
    </button>
  );
}
